<template>
  <div class="fccGestaoCadastrosTipoContato">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :orderby="sortBy"
            :status="status"
            :actions="actions"
            addFilter
            :items="listarGestaoCadastrosTipoContato"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            fieldVisibility
            pdf
            csv
            xls
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          >
          </fccTable>
        </div>
      </div>
    </div>
    <fccModal
      centered
      idModal="addFieldGestaoCadastrosTipoContatoModal"
      titleModal="Novo Tipo de Contato"
      escondeFooter
      travaEsc
      travaBack
    >
      <form @submit.prevent="criarGestaoCadastrosTipoContato" autocomplete="off">
        <div class="my-2">
          <div class="row">
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" required v-model="criar.tipo"
                >Tipo de Contato</fccInput
              >
            </div>
          </div>
          <div class="row my-4">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </div>
      </form>
    </fccModal>
    <fccModal
      centered
      idModal="editFieldGestaoCadastrosTipoContatoModal"
      titleModal="Editar Tipo de Contato"
      escondeFooter
      travaEsc
      travaBack
    >
      <form @submit.prevent="editarGestaoCadastrosTipoContato" autocomplete="off">
        <div class="my-2">
          <div class="row my-2">
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" required v-model="editar.tipo"
                >Tipo de Contato</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <label>Ativo</label><br />
              <toggle-button v-model="editar.ativo" />
            </div>
          </div>
          <div class="row my-4">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Gestão de Cadastros - Tipo de Contato',
      titlePDF: 'Gestão de Cadastros - Tipo de Contato',
      itemPorPage: '100',
      baseUrlConcursos: store.state.baseUrlConcursos,
      listagemGestaoCadastrosTipoContato: [],
      editar: {
        idTipoContato: '',
        tipo: '',
        ativo: false
      },
      fields: [
        { key: 'idtipocontato', label: 'ID', sortable: true, active: true },
        { key: 'tipo', label: 'Tipo de Contato', sortable: true, active: true },
        {
          key: 'status',
          label: 'Ativo',
          sortable: false,
          tdClass: 'no-print',
          thClass: 'no-print',
          active: true
        },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ],
      criar: {
        idTipoContato: 0,
        tipo: '',
        ativo: false
      },
      actions: [
        {
          button: true,
          funcaoButton: 'editFieldGestaoCadastrosTipoContato',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteFieldGestaoCadastrosTipoContato',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      status: [
        {
          funcaoButton: 'changeStatusGestaoCadastrosTipoContato',
          tooltip: 'Alterar Status',
          campoStatus: 'ativo',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ]
    }
  },
  methods: {
    changeStatusGestaoCadastrosTipoContato: function (action, item) {
      this.editar = item
      this.editarGestaoCadastrosTipoContato()
    },
    listandoGestaoCadastrosTipoContato: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(this.baseUrlConcursos + 'TipoContato/Listar', this.dadosLoginSession.fccTokenHeaders)
        .then((response) => {
          this.listagemGestaoCadastrosTipoContato = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    addField: function () {
      this.$root.$emit('bv::show::modal', 'addFieldGestaoCadastrosTipoContatoModal')
    },
    editFieldGestaoCadastrosTipoContato: function (action, item) {
      this.editar = item
      this.$root.$emit('bv::show::modal', 'editFieldGestaoCadastrosTipoContatoModal')
    },
    deleteFieldGestaoCadastrosTipoContato: function (action, item) {
      this.callConfirm(this.mensagemExcluir, item.tipo).then(() => {
        axios
          .delete(
            this.baseUrlConcursos + 'TipoContato/Excluir/' + item.idtipocontato,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listandoGestaoCadastrosTipoContato()
            this.callToast(this.mensagensUpdate.editado)
          })
          .catch((error) => {
            this.setErrorSystem(error)
          })
      })
    },
    criarGestaoCadastrosTipoContato: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      this.criar.idTipoContato = 0
      axios
        .post(
          this.baseUrlConcursos + 'TipoContato/Adicionar',
          this.criar,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoGestaoCadastrosTipoContato()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'addFieldGestaoCadastrosTipoContatoModal')
          this.callToast(this.mensagensUpdate.adicionado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'addFieldGestaoCadastrosTipoContatoModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    editarGestaoCadastrosTipoContato: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlConcursos + 'TipoContato/Alterar',
          this.editar,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoGestaoCadastrosTipoContato()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'editFieldGestaoCadastrosTipoContatoModal')
          this.callToast(this.mensagensUpdate.editado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'editFieldGestaoCadastrosTipoContatoModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    }
  },
  mounted: function () {
    this.listandoGestaoCadastrosTipoContato()
  },
  computed: {
    listarGestaoCadastrosTipoContato() {
      return this.listagemGestaoCadastrosTipoContato
    }
  }
}
</script>
